// CMG GED simulator entry — mounts CmgSimulatorGed from @twg/calculators onto the
// Slim-rendered `#paje-simulator-ged` scaffold.
import { createApp, type App } from 'vue'
import { CmgSimulatorGed } from '@twg/calculators'

interface SimulatorElement extends HTMLElement {
  __vueApp__?: App
}

function mountSimulator(): void {
  const el = document.getElementById('paje-simulator-ged') as SimulatorElement | null
  if (!el) return
  if (el.__vueApp__) return

  const origin = el.dataset.origin || 'single_tool'
  const contractIdAttr = el.dataset.contractId
  const contractId = contractIdAttr && contractIdAttr.length > 0 ? contractIdAttr : null

  const app = createApp(CmgSimulatorGed, { origin, contractId })
  app.mount(el)
  el.__vueApp__ = app
}

function unmountSimulator(): void {
  const el = document.getElementById('paje-simulator-ged') as SimulatorElement | null
  if (!el?.__vueApp__) return
  el.__vueApp__.unmount()
  delete el.__vueApp__
}

function handleMaxErrorScroll(event: MouseEvent): void {
  const target = event.target as Element | null
  if (!target?.closest('.cmg-maxerror')) return
  document.getElementById('global-result')?.scrollIntoView()
}

function bootstrapPageBehavior(): void {
  mountSimulator()
  if (document.getElementById('paje-simulator-ged')) {
    document.body.addEventListener('click', handleMaxErrorScroll)
  }
}

bootstrapPageBehavior()

document.addEventListener('turbo:load', bootstrapPageBehavior)

document.addEventListener('turbo:before-cache', () => {
  unmountSimulator()
  document.body.removeEventListener('click', handleMaxErrorScroll)
})
